var browserHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

var triangle1 = document.getElementById('triangle1');
var triangle2 = document.getElementById('triangle2');
var triangle3 = document.getElementById('triangle3');
var homeLayoutImage = document.querySelector('.home-layout__background');

function initHomeLayout() {
    var layoutWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var adjustWidth = 0;
    if(layoutWidth > 2560) {
        adjustWidth = (layoutWidth - 2560)/2;
    }
    if (triangle1) {
        var homeItem1 = document.querySelector('.home-layout__item--1');
        var triangle1Pos = triangle1.getBoundingClientRect();
        homeItem1.style.left = triangle1Pos.x - homeItem1.dataset.xpos - adjustWidth + "px";
        homeItem1.style.top = triangle1Pos.y - homeItem1.dataset.ypos + "px";
    }
    if (triangle2) {
        var homeItem2 = document.querySelector('.home-layout__item--2');
        var triangle2Pos = triangle2.getBoundingClientRect();
        homeItem2.style.left = triangle2Pos.x - homeItem2.dataset.xpos - adjustWidth + "px";
        homeItem2.style.top = triangle2Pos.y - homeItem2.dataset.ypos + "px";
    }
    if (triangle3) {
        var homeItem3 = document.querySelector('.home-layout__item--3');
        var triangle3Pos = triangle3.getBoundingClientRect();
        homeItem3.style.left = triangle3Pos.x - homeItem3.dataset.xpos - adjustWidth + "px";
        homeItem3.style.top = triangle3Pos.y - homeItem3.dataset.ypos + "px";
    }
    // if(homeLayoutImage) {
    //     homeLayoutImage.addEventListener('load',function(){
    //         homeLayoutImage.classList.add('loaded');
    //     })
    // }
}

window.addEventListener("resize", function () {
    initHomeLayout();
});

initHomeLayout();

//Handle events.
var homeLayoutElements = document.querySelectorAll('.home-layout__element');
homeLayoutElements.forEach(function(element){
    var linkedElement = element.dataset.linked;
    element.addEventListener('click', function () {
        var linkElement = element.dataset.link;
        document.querySelector(linkElement + ' a').click();
    });
    element.addEventListener('focus', function () {
        element.classList.add('has-focus');
        document.querySelector(linkedElement).classList.add('has-focus');
    });
    element.addEventListener('blur', function () {
        element.classList.remove('has-focus');
        document.querySelector(linkedElement).classList.remove('has-focus');
    });
    element.addEventListener('mouseenter', function () {
        element.classList.add('has-focus');
        document.querySelector(linkedElement).classList.add('has-focus');
    });
    element.addEventListener('mouseleave', function () {
        element.classList.remove('has-focus');
        document.querySelector(linkedElement).classList.remove('has-focus');
    });
});
